'use client';

import { useEffect } from 'react';
import { reportError, isChunkLoadError, reloadIfStaleBuild } from '../lib/error-logger';
import Link from 'next/link';
import ErrorPageTracker from './ErrorPageTracker';

// En el servidor, un error acá sale como 5xx y el Worker lo responde como 503 con Retry-After
// (cloudflare/worker.js): casi siempre es cyclone limitando pedidos, y se arregla solo.
export default function Error({ error, reset }) {
  useEffect(() => {
    console.error('Error boundary:', error);

    if (isChunkLoadError(error?.message)) {
      window.location.reload();
      return;
    }

    reloadIfStaleBuild(error?.stack).then((reloaded) => {
      if (!reloaded) reportError(error);
    });
  }, [error]);

  return (
    <>
      {!isChunkLoadError(error?.message) && <ErrorPageTracker error={error} boundary="app" />}
      <div className="min-h-screen bg-gradient-to-br from-white via-blue-50/30 to-red-50/30 flex flex-col justify-center items-center px-4">
        <div className="max-w-md w-full space-y-6 bg-white/80 backdrop-blur-xs p-10 rounded-xl shadow-md text-center">
          <h2 className="text-2xl font-bold text-[#1a1a1a]">Algo salió mal</h2>
          <p className="text-sm text-gray-500">
            No pudimos cargar esta página. Probá de nuevo en unos segundos.
          </p>
          <div className="flex flex-col gap-3 mt-6">
            <button
              onClick={() => reset()}
              className="w-full px-6 py-2.5 rounded-xl bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              Intentar de nuevo
            </button>
            <Link
              href="/"
              className="w-full px-6 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
            >
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
